import { Player } from "../classes/Player";

export const arrangePlayers = (players: Player[], playerId: number) => {
    players.sort((a, b) => a.joinTime > b.joinTime ? 1 : a.joinTime < b.joinTime ? -1 : 0);
    const tempPlayers = [...players];
    let distanceFromHost = 0;
    const playerIdx = players.findIndex((p) => p.id === playerId);
    if (playerIdx >= 0)
    {
        distanceFromHost = playerIdx; // since the list is sorted, host has the smallest joinTime, therefore host is players[0]
    }
    for (let idx = 0; idx < players.length; idx++)
    {
        const player = tempPlayers[idx];
        const newIdx = idx - distanceFromHost >= 0 ? idx - distanceFromHost : players.length + idx - distanceFromHost;
        players[newIdx] = player;
    }
    return players;
}